import { useEffect, useState } from "react";
import { PortalShell } from "@/components/AppHeader";
import { BaseMap, DEFAULT_CENTER, Heat } from "@/lib/mapProvider";
import { api } from "@/lib/api";

export default function BusyAreas() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/driver/busy-areas").then(({ data }) => setData(data)); }, []);
  return (
    <PortalShell>
      <p className="lux-eyebrow">Last 30 days of pickups</p>
      <h1 className="mt-2 text-3xl font-semibold text-amber-50 sm:text-4xl">Busy areas</h1>
      <div className="mt-8 grid gap-6 lg:grid-cols-[minmax(0,1fr)_320px]">
        <div className="relative z-0 min-w-0 overflow-hidden rounded-2xl border border-amber-500/15" data-testid="busy-heatmap">
          <BaseMap center={DEFAULT_CENTER} zoom={11} className="h-[380px] w-full sm:h-[560px]">
            {data && <Heat cells={data.cells} />}
          </BaseMap>
        </div>
        <div className="lux-card p-5 sm:p-6" data-testid="busy-top-areas">
          <p className="lux-eyebrow">Top 5 pickup areas</p>
          <ol className="mt-4 space-y-3">
            {data?.top_areas.map((a, i) => (
              <li key={a.name} data-testid={`busy-area-${i}`} className="flex items-center justify-between gap-3 text-sm">
                <span className="text-amber-100"><span className="mr-2 font-mono text-amber-400">{i + 1}</span>{a.name}</span>
                <span className="text-zinc-400">{a.count}</span>
              </li>
            ))}
          </ol>
          {data && <p className="mt-6 text-xs text-zinc-500">{data.total_pickups} pickups · areas are approximate (~1 km); no customer names or addresses are shown.</p>}
        </div>
      </div>
    </PortalShell>
  );
}
